import 'react-phone-input-2/lib/style.css';
import { Container } from './styled';
import PropTypes from 'prop-types';
import ReactPhoneInput from 'react-phone-input-2';
import { config } from 'config';
import { useTheme } from 'styled-components';
import React, { useEffect, useRef } from 'react';
const { defaultPhone } = config;

const PhoneInput = ({
    defaultValue = defaultPhone.code,
    disabled = false,
    height = '40px',
    margin = '0px',
    name = 'cellphone_number',
    onChange = () => null,
    required = true,
    value = '',
    width = '100%'
}) => {
    
    const containerRef = useRef();

    const { fontFamily, primaryLighterColor, textColor } = useTheme();

    useEffect(() => {
        const container = containerRef.current;
        const input = container.querySelector('input');
        const dropdown = container.querySelector('.flag-dropdown');
        dropdown.parentNode.insertBefore(dropdown, input);
    }, []);

    const containerProps = {
        margin
    };

    const inputProps = {
        height,
        width
    };
    
    return (
        <Container ref={ containerRef } { ...containerProps }>
            <ReactPhoneInput
                autoFormat={ false }
                buttonStyle={{
                    zIndex: 1
                }}
                defaultCountry={ defaultPhone.country }
                disabled={ disabled }
                inputExtraProps={{
                    name,
                    required
                }}
                inputStyle={{
                    ...inputProps,
                    backgroundColor: '#FFFFFF',
                    border: 'solid 1px',
                    borderColor: primaryLighterColor,
                    borderRadius: '4px',
                    boxShadow: 'inherit',
                    boxSizing: 'border-box',
                    color: `${ textColor }`,
                    fontFamily: fontFamily ? fontFamily : 'Montserrat, sans-serif',
                    fontSize: '14px',
                    fontWeight: 'normal',
                    marginRight: 0,
                    outline: 'none'
                }}
                value={ value ? value : defaultValue }
                onChange={ onChange }
            />
        </Container>
    );
};

PhoneInput.propTypes = {
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    height: PropTypes.string,
    margin: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    value: PropTypes.string,
    width: PropTypes.string
};

export default PhoneInput;
